import React from "react";

const RotationControlPanel = ({
    strapRotation, setStrapRotation,
    isRotateOpen, setIsRotateOpen,
    isMobile,
    isOrderFinished, isFreeMoveLocked,
    cutOption,
}) => {
    if (cutOption !== 'free' || isOrderFinished || isFreeMoveLocked || !setStrapRotation) return null;

    return (
        <div style={{ position: 'absolute', bottom: isMobile ? '108px' : '36px', left: isMobile ? '24px' : '36px', zIndex: 900, userSelect: 'none' }}>
            {isRotateOpen && (
                <div style={{ position: 'absolute', bottom: '50px', left: 0, backgroundColor: '#F6F5F0', border: '1px dashed #C5A075', borderRadius: '24px', padding: '8px 6px', boxShadow: '0 4px 20px rgba(0,0,0,0.12)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', minWidth: '42px', animation: 'rotPanelIn 0.18s ease-out' }}>
                    <button onClick={() => setStrapRotation(r => (r + 15) % 360)} style={{ width: '30px', height: '28px', border: 'none', backgroundColor: 'transparent', color: '#8B6914', cursor: 'pointer', fontSize: '16px', lineHeight: 1, borderRadius: '50%' }}>↻</button>
                    <div style={{ width: '24px', height: '1px', backgroundColor: 'rgba(197,160,117,0.4)' }} />
                    {[0, 90, 180, 270].map(deg => (
                        <button key={deg} onClick={() => setStrapRotation(deg)}
                            style={{ width: '30px', height: '26px', cursor: 'pointer', borderRadius: '6px', border: strapRotation === deg ? '1px solid #8B6914' : '1px solid transparent', backgroundColor: strapRotation === deg ? 'rgba(139,105,20,0.12)' : 'transparent', color: strapRotation === deg ? '#8B6914' : '#A89070', fontSize: '9px', fontWeight: 700, lineHeight: 1 }}>
                            {deg}°
                        </button>
                    ))}
                    <div style={{ width: '24px', height: '1px', backgroundColor: 'rgba(197,160,117,0.4)' }} />
                    <button onClick={() => setStrapRotation(r => ((r - 15) + 360) % 360)} style={{ width: '30px', height: '28px', border: 'none', backgroundColor: 'transparent', color: '#8B6914', cursor: 'pointer', fontSize: '16px', lineHeight: 1, borderRadius: '50%' }}>↺</button>
                </div>
            )}
            <button
                onClick={() => setIsRotateOpen(o => !o)}
                className="btn rounded-circle d-flex justify-content-center align-items-center shadow-sm"
                style={{ width: '42px', height: '42px', backgroundColor: isRotateOpen ? '#EDE7DA' : '#F6F5F0', border: strapRotation !== 0 ? '1px dashed #8B6914' : '1px dashed #C5A075', color: '#8B6914', cursor: 'pointer', fontSize: strapRotation !== 0 ? '9px' : '18px', fontWeight: strapRotation !== 0 ? 700 : 400, lineHeight: 1, transition: 'all 0.2s' }}
            >
                {strapRotation !== 0 ? `${strapRotation}°` : '↻'}
            </button>
        </div>
    );
};

export default RotationControlPanel;
